import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Box, Tooltip, Text } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';
import { getFieldValueByCalculator } from '../utils';

import type { MonthlyPaymentInputProps } from '../types';

const MortgagePaymentInput = (props: MonthlyPaymentInputProps): JSX.Element => {
  const {
    value,
    label = 'Mortgage Payment',
    tooltip = 'This is the amount that you pay each month that goes toward paying down the principal of the loan and the cost of borrowing (interest).',
  } = props;

  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  const tooltipLabel = label;

  return (
    <Box
      display="flex"
      flexDirection={{ desktop: 'column', mobile: 'row' }}
      justifyContent="space-between"
    >
      <Box>
        {/* @ts-ignore - ignore type error for label */}
        <Tooltip label={tooltipLabel} content={tooltip} />
      </Box>
      <Box>
        <Text size="small" bold>
          {currencyValue}
        </Text>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  return {
    value: getFieldValueByCalculator(state, calculator, 'mortgagePayment'),
  };
};

export default connect(mapStateToProps)(MortgagePaymentInput);
